import styled from 'styled-components';

import {colors} from 'theme';

export const Root = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
    height: auto;
`;

export const Description = styled.span`
    width: 100%;
    text-align: center;
    font-size: 14px;
    color: ${colors.textPrimary};
`;

export const ButtonsContainer = styled.div`
    display: flex;
    gap: 10px;
`;
